import React from 'react';

// The app's search-match highlight - browser Ctrl+F style yellow, the same
// everywhere a search marks what it matched.
export const HIGHLIGHT_COLOR = '#ffe066';

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// `text` with every case-insensitive occurrence of `term` marked, so it's
// obvious at a glance why a row matched.
export const highlightMatch = (text: string, term: string): React.ReactNode => {
    if (!term) return text;
    const parts = text.split(new RegExp(`(${escapeRegExp(term)})`, 'gi'));
    return parts.map((part, i) =>
        part.toLowerCase() === term.toLowerCase()
            ? <mark key={i} style={{ background: HIGHLIGHT_COLOR, color: 'inherit', borderRadius: 2, padding: '0 1px' }}>{part}</mark>
            : part
    );
};
